import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Checkbox, FormControlLabel} from 'views/components';
import {Translate, translate} from 'views/module';

const AgreementsSection = (props) => {
  const {agreements, onAgreementsChange, setValidity, setDisableNext} = props;

  const agreementItemKeys = Object.keys(translate('caregiverScreening.Agreements.Items'));

  const [checked, setChecked] = React.useState(() => {
    const temp = {};
    agreementItemKeys.forEach((itemKey) => {
      temp[itemKey] = agreements[itemKey] || false;
    });
    return temp;
  });

  React.useEffect(() => {
    const areAllChecked = agreementItemKeys.every((key) => checked[key]);
    setValidity(areAllChecked);
    setDisableNext(!areAllChecked);
    onAgreementsChange(checked);
  }, [checked, setValidity, setDisableNext, onAgreementsChange]);

  const toggleItem = (key) => {
    setChecked((prev) => ({...prev, [key]: !prev[key]}));
  };

  return (
    <Box sx={{p: 3}}>
      <Typography variant="h5" gutterBottom align="center" fontWeight={600}>
        <Translate expression='caregiverScreening.Agreements.Title' />
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center" sx={{mb: 2}}>
        <Translate expression='caregiverScreening.Agreements.Subtitle' />
      </Typography>
      <Box sx={{mt: 2, mb: 2}}>
        <Stack spacing={2}>
          {
            agreementItemKeys.map((key) => (
              <Box key={key} sx={{display: 'flex', alignItems: 'flex-start', gap: 1}}>
                <FormControlLabel
                  control=
                    {
                      <Checkbox
                        label={
                          <Box>
                            <Typography variant="subtitle1" fontWeight={600}>
                              <Translate expression={`caregiverScreening.Agreements.Items.${key}.Label`} />
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              <Translate expression={`caregiverScreening.Agreements.Items.${key}.Description`} />
                            </Typography>
                          </Box>
                        }
                        checked={checked[key]}
                        onChange={() => toggleItem(key)}
                        color="primary"
                      />
                    }
                />
              </Box>
            ))
          }
        </Stack>
      </Box>
    </Box>
  );
};

AgreementsSection.propTypes = {
  agreements: PropTypes.object.isRequired,
  onAgreementsChange: PropTypes.func.isRequired,
  setValidity: PropTypes.func.isRequired,
  setDisableNext: PropTypes.func.isRequired,
};

export default AgreementsSection;
